module.exports = __webpack_public_path__ + "assets/img/38aa7421723b29a535d756c7baf408bc.png";